import { Component,Input, SimpleChanges, PipeTransform, Pipe, ViewChild, ElementRef, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/shared/services/data.service';
import { RenderService } from 'src/app/shared/services/render.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { AngularBlockListType } from 'src/app/models/enums/angularBlockListType';

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: any) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@Component({
  selector: 'app-department-info',
  templateUrl: './department-info.component.html',
  styleUrls: ['./department-info.component.scss', './department-info-blocklists.scss', './department-info-blocklists.en.scss'],
})

export class DepartmentInfoComponent implements OnInit {
  constructor(
    private dataService: DataService, 
    private renderService: RenderService,
    private router: Router, 
    private route: ActivatedRoute
  ){}

  @Input () pageNodeId: any;
  @Input () componentData : any;
  @Input () mainTabsIds: any;
  @Input () isPageLoading!: boolean;
  
  angularBlockListType = AngularBlockListType;
  getSubTabUrl  = environment.apiUrl + "/umbraco/Surface/DepartmentInfoSurface/SubMainTabInit";
  getMainTabUrl = environment.apiUrl + "/umbraco/Surface/DepartmentInfoSurface/MainTabInit";

  selectedMainTabId : any;
  selectedSubTabId: any;

  selectedMainTabData: any;
  selectedSubTabData: any;
  
  currentRoute : string ='';
  isMainTabLoading: boolean = false;
  isSubTabLoading: boolean = false;
  anchorInitialized = false;

  ngOnInit(): void {
    if(this.isPageLoading){
      this.isMainTabLoading = true;
      this.isSubTabLoading = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!this.selectedMainTabId){
      this.route.queryParams.subscribe(params => {
        this.selectedMainTabId = +params['mainTab'] ? +params['mainTab'] : 0;
        this.selectedSubTabId = +params['subTab'] ? +params['subTab'] :  0;
      });
    }
    if (changes['componentData'] && changes['componentData'].currentValue) {
      if(this.selectedMainTabId === 0)
      {
        this.selectedMainTabId = this.componentData.mainTabs[0].selectedTabNodeId;
        this.selectedMainTabData = this.componentData;
        this.selectedSubTabId = this.componentData.selectedMainTab.subTabs[0].selectedTabNodeId;
        this.getSubTabContent();
      }
      else if(this.componentData){
        this.selectedMainTabData = this.componentData;
        this.getSubTabContent();
      }
      else {
        this.getMainTabContent();
      }
    }
  }

  scrollToAnchor() {
    if (this.anchorInitialized) {
      return;
    }

    this.anchorInitialized = true;
    let anchorId = this.route.snapshot.fragment;
    if (!anchorId) {
      return;
    }
    anchorId = anchorId.charAt(0).toLowerCase()+anchorId.slice(1);
    const blocklist = document.querySelector(`[blocklist-id="${anchorId}"]`);
    if(blocklist)
      blocklist.scrollIntoView({behavior: 'smooth'})
  }

  selectedSubTabIndex()
  {
    if(this.selectedSubTabId !== 0)
      return this.selectedMainTabData.selectedMainTab.subTabs.findIndex(
        (subTab : any) => subTab.nodeId === this.selectedSubTabId
      );
    return 0;
  }

  selectedMainTabIndex()
  {
    if(this.selectedMainTabData)
      return this.selectedMainTabData.mainTabs.findIndex(
        (mainTab : any) => mainTab.nodeId === this.selectedMainTabId
      );
    return 0;
  }

  handlerMainTabClick(event: any) {
    if(this.selectedMainTabData)
    {
      const selectedTabIndex = event.index;
      const selectedMainTab = this.selectedMainTabData.mainTabs[selectedTabIndex];

      this.updateUrlParameters();

      if(selectedMainTab.nodeId !== this.selectedMainTabId)
      {
        this.selectedMainTabId = selectedMainTab.nodeId;
        this.selectedSubTabId = 0;
        this.getMainTabContent();
      }
    }
  }

  handlerSubTabClick(event: any) {
    if(this.selectedMainTabData && !this.isSubTabLoading)
    {
      const selectedTabIndex = event.index;
      const selectedSubTab = this.selectedMainTabData.selectedMainTab.subTabs[selectedTabIndex];
      this.selectedSubTabId = selectedSubTab.nodeId;

      this.updateUrlParameters();

      this.getSubTabContent();
    }
  }

  async getSubTabContent()
  {
    var payload: any = {
      pageNodeId: this.pageNodeId,
      selectedSubTabId: this.selectedSubTabId,
      selectedTabId: this.selectedMainTabId,
      cultureCode: this.dataService.getCultureCode()
    }
    this.isSubTabLoading = true;
    var data = await this.request(this.getSubTabUrl, payload);
    if(data)
    {
      this.selectedSubTabData = data;
      const aliasCount:any = {};
      for (const block of this.selectedSubTabData.blockLists) {
        const alias = block.angularComponentName;
        if (!aliasCount[alias]) {
            aliasCount[alias] = 1;
            block.id = alias;
        } else {
            aliasCount[alias]++;
            block.id = `${alias}-${aliasCount[alias]}`;
        }
      }  
      this.isSubTabLoading = false;
      setTimeout(() => {
        this.scrollToAnchor();
    }, 50)
    }
  }

  async getMainTabContent() 
  {
    var payload: any = {
      selectedTabId: this.selectedMainTabId,
      mainTabsIds: this.mainTabsIds,
      selectedSubTabId: this.selectedSubTabId != 0 ? this.selectedSubTabId : null,
      cultureCode: this.dataService.getCultureCode()
    }
    this.isMainTabLoading = true;
    var data = await this.request(this.getMainTabUrl, payload);
    if(data)
    {
      this.selectedMainTabData = data;
      this.selectedSubTabId = this.selectedMainTabData.selectedMainTab.subTabs[0]?.selectedTabNodeId;
      this.isMainTabLoading = false;
      this.getSubTabContent();
    }
  }

  async request(url: string, payload: any): Promise<any>
  {
    return new Promise<any>((resolve, reject) => {
      this.dataService.getDataByToken(url, payload).subscribe({
        next: (data) => {
          resolve(JSON.parse(data));
        },
        complete: () => {
          this.additionalBindMainScripts();
        },
        error: (error) => {
          console.error(error);
        }
      });
    });
  }

  additionalBindMainScripts()
  {
    setTimeout(() => {
      this.renderService.bindMainScripts();
    }, 100);
  }


  private updateUrlParameters() {
    let queryParams: any = {};

    if(this.selectedMainTabId) {
      queryParams.mainTab = this.selectedMainTabId;
    }

    if(this.selectedSubTabId) {
      queryParams.subTab = this.selectedSubTabId;
    }

    queryParams = Object.keys(queryParams).length > 0 ? queryParams : null;

    var url = this.router.createUrlTree([], {
        relativeTo: this.route,
        queryParams: queryParams,
      })
      .toString();

    window.history.pushState({ path: url }, '', url);
  }
}
